import React from "react";
import { V19Page } from "./V19Page";
export default function Encounters() {
  return <V19Page view="encounters" testid="encounters-view" />;
}
